import React from 'react';

import { Typography, Avatar } from '@mui/material';

import { CustomLayerButton } from './Button/CustomButton';

export const MapSettingIcon = ({id, active, icon, setAction, label, ariaLabel=''}) => {
  const styles = {
    labelButton: {
      fontStyle: 'normal',
      fontSize: '1em',
    }
  };
  return ( 
    <CustomLayerButton 
      id={id}
      variant='contained'
      aria-label={ariaLabel} 
      activebutton={active ? 'true' : 'false'}
      startIcon={
        <Avatar alt='' src={icon} variant="square" sx={{ width: 24, height: 24 }}/>
      } 
      onClick={setAction} >
      <Typography aria-hidden={true} sx={styles.labelButton}>
        {label}
      </Typography>
    </CustomLayerButton>
  );
};